module.exports = [{
      plugin: require('/zeit/77b215bd/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
